import styled from 'styled-components'

export const ModalContent = styled.div`
  padding: ${({ theme }) => theme.spacing.large};
`

export const Title = styled.h2`
  margin: 0 0 ${({ theme }) => theme.spacing.small} 0;
  font-size: ${({ theme }) => theme.typography.fontSize.title};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
`

export const Description = styled.p`
  margin: 0 0 ${({ theme }) => theme.spacing.large} 0;
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 1.5;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
`

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xsmall};
`

export const Label = styled.label`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.primary};
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  justify-content: flex-end;
  margin-top: ${({ theme }) => theme.spacing.medium};
`

export const MessageContainer = styled.div<{ $type: 'success' | 'error' }>`
  padding: ${({ theme }) => theme.spacing.small}
    ${({ theme }) => theme.spacing.default};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  background-color: ${({ theme, $type }) =>
    $type === 'success' ? theme.colors.successLight : '#ffe5e3'};
  color: ${({ theme, $type }) =>
    $type === 'success' ? theme.colors.success : theme.colors.danger};
  margin-bottom: ${({ theme }) => theme.spacing.default};
`

export const ErrorMessage = styled.div`
  margin-top: ${({ theme }) => theme.spacing.xsmall};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.danger};
`
